import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-modal-header-only',
  templateUrl: './modal-header-only.component.html',
  styleUrls: ['./modal-header-only.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalHeaderOnlyComponent {}
